import { render, staticRenderFns } from "./VerifySmsCaptchaModal.vue?vue&type=template&id=fbdcd4d6&"
import script from "./VerifySmsCaptchaModal.vue?vue&type=script&lang=js&"
export * from "./VerifySmsCaptchaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports